import {
  BrowserRouter, Routes, Route
} from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import './index.css';
import { CssBaseline } from '@mui/material';
import Box from '@mui/material/Box';
import Signin from './component/Signin';
import LandingPage from './component/LandingPage';
import Main from './component/Main';
import ConfigurationCAF from './component/ConfigurationCAF';
import ConfigurationCR from './component/ConfigurationCR';
import CollectLoginInfo from './component/CollectLoginInfo';
import ConfigurationCFR from './component/ConfigurationCFR';
import ConfigurationWFM from './component/ConfigurationWFM';
import ConfigurationAO from './component/ConfigurationAO';
import ConfigurationAS from './component/ConfigurationAS';
import ConfigurationCBO from './component/ConfigurationCBO';
import Logout from './component/Logout';
import axios from 'axios';
import Slide from '@mui/material/Slide';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import PropTypes from 'prop-types';
import DrawerCustom from './component/Drawer';

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};


export default function App(props) {
  const [setAnchorEl] = React.useState(null);
  const [user, setUser] = useState("")


  const handleClose = () => {
    setAnchorEl(null);
  };


  useEffect(() => {
    async function getUserInfo() {
      const response = await fetch('/.auth/me');
      const payload = await response.json();
      const { clientPrincipal } = payload;
      if (clientPrincipal == null) {
        localStorage.setItem('isAuthenticated', 'false');
        localStorage.setItem('username', " ");
        setUser(" ")
      }
      else if (response.status === 200) {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('username', clientPrincipal.userDetails);
        setUser(clientPrincipal.userDetails)

      }
      return clientPrincipal;
    }
    getUserInfo();
    
  })

  useEffect(() => {
    setInterval(() => {
      clearSession()
      window.location.href = "/.auth/logout?post_logout_redirect_uri=/logout"
    }, 3600000)
  })


  async function clearSession() {
    let userName = localStorage.getItem('username')
    localStorage.clear();
    handleClose();
    let event = {
      user: userName,
      time: new Date(Date.now()).toISOString(),
      action: "Admin UI Log-Out Successful",
    }

    let result = await axios.post('/api/send-splunk-data', { event },
      { headers: { 'Content-type': 'application/x-www-form-urlenconded' } })
  }


  return (
    <BrowserRouter>
      {window.location.pathname !== '/Logout' && window.location.href.indexOf("configuration") > -1 ?
        <React.Fragment>
          <Box sx={{ display: 'flex' }}>
          <CssBaseline />
            <DrawerCustom />
            </Box>
        </React.Fragment>
        : ""}
      <main>
        <Routes>
          <Route path="/" element={<Signin />} />
          <Route path="/main" element={<Main />} />
          <Route path="/configuration-wfm" element={<ConfigurationWFM />} />
          <Route path="/configuration-cfr" element={<ConfigurationCFR />} />
          <Route path="/configuration-caf" element={<ConfigurationCAF />} />
          <Route path="/loginInfoRedirect" element={<CollectLoginInfo />} />
          <Route path="/configuration-cr" element={<ConfigurationCR />} />
          <Route path="/configuration-ao" element={<ConfigurationAO />} />
          <Route path="/configuration-as" element={<ConfigurationAS />} />
          <Route path="/configuration-cbo" element={<ConfigurationCBO />} />
          <Route path="/configuration-cct-main" element={<LandingPage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/auth/logout" element={<Logout />} />
        </Routes>
      </main>
    </BrowserRouter>
  );
}